// @ts-strict-ignore
import React, { type ComponentProps, memo } from 'react';

import { View } from '../common/View';

import { MonthPicker } from './MonthPicker';
import { getScrollbarWidth } from './util';

type BudgetPageHeaderProps = {
  startMonth: string;
  onMonthSelect: (month: string) => void;
  numMonths: number;
  monthBounds: ComponentProps<typeof MonthPicker>['monthBounds'];
  sparseMonths?: string[];
  activeMonth?: string;
  headerLeft?: React.ReactNode;
};

export const BudgetPageHeader = memo<BudgetPageHeaderProps>(
  ({ startMonth, onMonthSelect, numMonths, monthBounds, sparseMonths, activeMonth, headerLeft }) => {
    const offsetMultipleMonths = numMonths === 1 ? 4 : 0;
    const leftWidth = 200 + 5 - offsetMultipleMonths;
    return (
      <View style={{ flexDirection: 'row', alignItems: 'center', flexShrink: 0, paddingTop: 10 }}>
        <div style={{ width: leftWidth, flexShrink: 0, paddingLeft: 8, boxSizing: 'border-box' }}>
          {headerLeft}
        </div>
        <View
          style={{
            flex: 1,
            marginRight: 5 + getScrollbarWidth() - offsetMultipleMonths,
            overflow: 'hidden',
            paddingBottom: 10,
          }}
        >
          <MonthPicker
            startMonth={startMonth}
            numDisplayed={numMonths}
            monthBounds={monthBounds}
            sparseMonths={sparseMonths}
            activeMonth={activeMonth}
            style={{}}
            onSelect={month => onMonthSelect(month)}
          />
        </View>
      </View>
    );
  },
);

BudgetPageHeader.displayName = 'BudgetPageHeader';
